
import { defineComponent, PropType } from 'vue';
import PdfViewer from '@/components/shared/pdf-viewer/PdfViewer.vue';
import { usePdfViewerBack } from '@/core/hooks/use-pdf-viewer-back';

export default defineComponent({
  name: 'PdfViewerPage',

  components: { PdfViewer },

  props: {
    title: {
      type: String,
      required: true,
    },
    titleSuffix: {
      type: String as PropType<string | null>,
      default: null,
    },
    count: {
      type: Number,
      default: 0,
    },
    countLabel: {
      type: String,
      default: '',
    },
    source: {
      type: String as PropType<string | null>,
      default: null,
    },
    fileName: {
      type: String,
      default: 'document.pdf',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadingMessage: {
      type: String,
      default: 'Đang tạo file PDF...',
    },
    fallbackRouteName: {
      type: String,
      default: undefined,
    },
  },

  setup(props) {
    const { goBack } = usePdfViewerBack(props.fallbackRouteName);
    return { goBack };
  },
});
